// extracted by mini-css-extract-plugin
export const locations = "locations-module--locations--3-ANg";
export const inverted = "locations-module--inverted--2Bytj";